import { GlobalOutlined } from '@ant-design/icons';
import { Menu } from 'antd';
import React from 'react';
import { SupportLanguage } from './i18n';

export interface Props {
    onLanguageChange: (domEvent: Event, key: string) => void;
}

const LanguageMenu: React.FunctionComponent<Props> = (props) => {
    return (
        <Menu
            mode='horizontal'
            style={{
                background: 'transparent',
                textAlign: 'right',
                paddingRight: 0,
            }}
            onClick={(param) =>
                props.onLanguageChange(param.domEvent, param.key)
            }
        >
            <Menu.SubMenu
                style={{ background: 'transparent' }}
                title={
                    <GlobalOutlined
                        style={{ fontSize: 17, color: 'white', marginRight: 0 }}
                    />
                }
            >
                <Menu.Item key={SupportLanguage.en_US}>English</Menu.Item>
                <Menu.Item key={SupportLanguage.zh_TW}>繁體中文</Menu.Item>
            </Menu.SubMenu>
        </Menu>
    );
};

export default LanguageMenu;
